module.exports = __webpack_public_path__ + "static/media/39.09c00c03.jpg";